
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_858_56469)"}},[_c('path',{attrs:{"d":"M11.787 7.825a2.5 2.5 0 114.12-.287 3.16 3.16 0 00-.282-.013h-2.5c-.463 0-.92.102-1.338.3zM7.5 16.275c-3.221-.016-5-1.146-5-3.406V11.9a1.875 1.875 0 011.875-1.875h5.688a3.23 3.23 0 00-.01.053A3.125 3.125 0 007.5 13.15v3.125zM10.625 5.65a3.125 3.125 0 10-6.25 0 3.125 3.125 0 006.25 0zm.625 5v.625h-.625A1.875 1.875 0 008.75 13.15v1.875h2.5V14.4a.625.625 0 111.25 0v.625h3.75V14.4a.625.625 0 111.25 0v.625H20V13.15a1.875 1.875 0 00-1.875-1.875H17.5v-.625a1.875 1.875 0 00-1.875-1.875h-2.5a1.875 1.875 0 00-1.875 1.875zm1.875-.625h2.5a.625.625 0 01.625.625v.625H12.5v-.625a.625.625 0 01.625-.625zM20 16.275h-2.5v.625a.624.624 0 11-1.25 0v-.625H12.5v.625a.624.624 0 11-1.25 0v-.625h-2.5v1.875a1.875 1.875 0 001.875 1.875h7.5A1.875 1.875 0 0020 18.15v-1.875z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_858_56469"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .025)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    